import React from 'react';
import {List, Datagrid, TextField, ReferenceField, NumberField, BooleanField, DateField} from 'react-admin';

export const FirmwareJobList = props => {
  console.log(props);
  return (
    <>
      <List title='Hydrant Fleet Management - Firmware Job' exporter={false} perPage={50}>
        <Datagrid isRowSelectable={()=>(false)}>
          <TextField label="Id" source="id" />
          {/* <TextField label="Firmware Id" source="firmwareId" /> */}
          <ReferenceField source='firmwareId' reference='firmwares'>
            <TextField source="version" />
          </ReferenceField>
          <NumberField label="Seq." source="sequenceNumber" format={v => v*100} parse={v => v/100}/>
          <TextField label="Device Id" source="deviceId" />
          <BooleanField label="Completed" source="isComplete"/>
          <DateField showTime label="Created" source="createdAt" />
        </Datagrid>
      </List>
    </>  
  );
};
